module.exports = __webpack_public_path__ + "media/Intro_Chris_desktop.mp4";